export const convertGoogleDriveFileStructureToUppyFile = (file) => {
    const fileExtensionFromName = file.name.split(".").pop() || file.type;
    return {
      id: file.id,
      name: file.name,
      type: file.type,
      data: new File([], file.name), //NOTE: We don't really need filedata of Gdrive files so we are passing in null values
      size: file.sizeBytes,
      source: "GoogleDrive",
      isRemote: true,
      extension: fileExtensionFromName,
      preview: file.iconUrl,
      meta: {
        thumbnail: {
          url: file.iconUrl,
        },
        serviceId: file.serviceId,
        description: file.description,
        lastEditedUtc: file.lastEditedUtc,
        name: file.name,
        url: file.url,
        embedUrl: file.embedUrl,
        parentId: file.parentId,
        originalId: file.id,
        isShared: file.isShared,
      },
      mimeType:file.mimeType
    };
  };
  
  export function convertGoogleDriverFolderFileToGoogleDriveFile(file) {
    const id = (file.shortcutDetails && file.shortcutDetails.targetId) || file.id;
    const mimeType = (file.shortcutDetails && file.shortcutDetails.targetMimeType) || file.mimeType;
    const type =
      mimeType === "application/vnd.google-apps.folder" ? "folder" : "file";
  
    return {
      id: id,
      serviceId: "google_drive", // Set this to whatever service ID you use
      mimeType: mimeType,
      name: file.name,
      description: "",
      type: type,
      meta: {},
      lastEditedUtc: new Date(file.modifiedTime).getTime(),
      iconUrl: file.iconLink,
      url: file.webViewLink || "",
      embedUrl: file.webContentLink || "",
      driveSuccess: true, // Assuming the transformation is successful
      driveError: "", // No error in this transformation
      sizeBytes: Number(file.size) || 0,
      parentId: file.parents ? file.parents[0] : undefined,
      isShared: file.shared,
    };
  }
  
